import React, { useState } from 'react';
import { Ruler, Download, Filter, Search, Layers, DoorOpen, Building } from 'lucide-react';

const RightSidebar = ({ projectId, onAnalysisTypeChange, currentAnalysisType, onRunAnalysis, isLoading }) => {
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  
  const handleSearch = async () => {
    if (!searchText) return;
    try {
      console.log(projectId)
      const apiUrl = import.meta.env.VITE_API_URL;
      const res = await fetch(
        `http://127.0.0.1:3003/search?query=${encodeURIComponent(searchText)}&projectId=${projectId}`
      );

      const data = await res.json();
      console.log(data.results); 
      setSearchResults(data.results);
    } catch (err) {
      console.error("Error fetching search results:", err);
    }
  };

  const analysisTypes = [
    {
      id: 'segmentation',
      name: 'Area Segmentation',
      icon: Layers,
      description: 'Detect and measure room areas',
      color: 'bg-green-600 hover:bg-green-700'
    },
    {
      id: 'detection',
      name: 'Doors & Windows',
      icon: DoorOpen,
      description: 'Detect doors and windows',
      color: 'bg-blue-600 hover:bg-blue-700'
    },
    {
      id: 'walls',
      name: 'Wall Detection',
      icon: Building,
      description: 'Detect and measure walls',
      color: 'bg-orange-600 hover:bg-orange-700'
    },
    {
    id: 'callout',
    name: 'Callout Detection',
    icon: Ruler,
    description: 'Detect section callouts',
    color: 'bg-purple-600 hover:bg-purple-700'
  }
  ];

  return (
    <div className="w-64 bg-gray-900 border-l border-gray-700 shadow-xl flex flex-col p-4 space-y-4 text-gray-100">
      <div className="space-y-3">
        <h3 className="text-lg font-semibold text-white mb-4">Analysis Tools</h3>
        
        {analysisTypes.map((type) => {
          const Icon = type.icon;
          const isActive = currentAnalysisType === type.id;
          const isCurrentlyLoading = isLoading && isActive;
          
          return (
            <div key={type.id} className="space-y-2">
              <button
                onClick={() => onAnalysisTypeChange(type.id)}
                disabled={isLoading}
                className={`w-full p-3 rounded-lg border transition-all duration-200 ${
                  isActive 
                    ? `${type.color} border-white/30 shadow-lg` 
                    : 'bg-gray-800 hover:bg-gray-700 border-gray-600'
                } ${isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
              >
                <div className="flex items-center space-x-3">
                  <Icon className="w-5 h-5" />
                  <div className="text-left flex-1">
                    <div className="font-medium text-sm">{type.name}</div>
                    <div className="text-xs opacity-75">{type.description}</div>
                  </div>
                </div>
              </button>
              
              {isActive && (
                <button
                  onClick={() => onRunAnalysis(type.id)}
                  disabled={isLoading}
                  className={`w-full py-2 px-3 rounded-md text-sm font-medium transition-all duration-200 ${
                    isCurrentlyLoading
                      ? 'bg-gray-600 cursor-not-allowed'
                      : `${type.color} hover:shadow-md`
                  }`}
                >
                  {isCurrentlyLoading ? (
                    <div className="flex items-center justify-center space-x-2">
                      <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                      <span>Processing...</span>
                    </div>
                  ) : (
                    `Run ${type.name}`
                  )}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RightSidebar;